import { lazy } from "react";

const SubmitProfile = lazy(() => import("./SubmitProfile"));

export { SubmitProfile };
